import Reveal from "./Reveal";
import { ArrowUpRight, CheckCircle2 } from "lucide-react";

const DOSSIER_URL = "https://candidature.alternativ-france.fr/dossier";

export default function LeadForm() {
  return (
    <section id="candidater" data-testid="lead-form-section" className="relative py-28 md:py-36 border-t border-emerald-400/10 overflow-hidden">
      <div className="absolute -bottom-40 left-1/3 w-[600px] h-[600px] rounded-full bg-emerald-500/10 blur-[160px] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center relative">
        <Reveal>
          <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-emerald-400 mb-6">05 — Ta candidature</p>
          <h2 className="font-display font-bold tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl mb-6">
            Le dossier complet,
            <br />
            <span className="text-emerald-400">à portée de clic.</span>
          </h2>
          <p className="text-base md:text-lg text-slate-400 leading-relaxed max-w-lg mb-10">
            Plan de lancement, conditions d&rsquo;exclusivité territoriale :
            tout ce qu&rsquo;il faut pour décider en connaissance de cause. Sans engagement,
            sans relance agressive.
          </p>
          <ul className="space-y-4">
            {["Réponse sous 24 h ouvrées", "Échange téléphonique sans engagement", "Territoire réservé 15 jours"].map((t) => (
              <li key={t} className="flex items-center gap-3 text-sm text-slate-300">
                <CheckCircle2 className="w-4 h-4 text-emerald-400 shrink-0" />
                {t}
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="rounded-[2rem] border border-emerald-400/20 bg-[#0E1713]/80 backdrop-blur-md p-8 md:p-12 text-center shadow-[0_40px_120px_-40px_rgba(16,185,129,0.35)]">
            <span className="mx-auto mb-8 w-16 h-16 rounded-full bg-emerald-400/15 grid place-items-center animate-beacon">
              <ArrowUpRight className="w-7 h-7 text-emerald-300" />
            </span>
            <h3 className="font-display font-bold text-2xl md:text-3xl mb-4">Prêt à candidater ?</h3>
            <p className="text-sm md:text-base text-slate-400 max-w-sm mx-auto leading-relaxed mb-10">
              Le dossier de candidature t&rsquo;attend sur la plateforme dédiée Alternativ.
              Quelques minutes suffisent pour vérifier si ton territoire est encore libre.
            </p>
            <a
              href={DOSSIER_URL}
              data-testid="submit-candidate-button"
              className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-emerald-400 text-[#070C0A] px-7 py-4 text-sm font-bold transition-all duration-300 hover:bg-emerald-300 hover:shadow-[0_0_36px_rgba(52,211,153,0.5)]"
            >
              Accéder au dossier de candidature
              <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <p className="mt-6 font-jbmono text-[11px] text-slate-600">
              candidature.alternativ-france.fr
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
